import type { Courier } from '@@partner:types:app'
import type { CRUD_Variables, GQL_Edge } from '@@partner:types:graphql'

import { gql, useLazyQuery, useQuery } from '@apollo/client'

import {
  SHORTCUT_EMPLOYEE_FIELDS,
  SHORTCUT_PAGE_INFO_FIELDS
} from '@@partner:graphql/shortcuts'

export interface AllCouriersQueryResult {
  couriers: GQL_Edge<Courier[]>
}

export interface AllCouriersQueryVariables extends CRUD_Variables {}

const GQL_QUERY_ALL_COURIERS = gql`
  query (
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    couriers: allCouriers(
      filter: $filter
      sort: $sort
      pager: $pager
    ) {
      edges {
        ${SHORTCUT_EMPLOYEE_FIELDS}
      }
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
    }
  }
`

export const useFetchAllCouriers = (variables: AllCouriersQueryVariables) =>
  useQuery<AllCouriersQueryResult, AllCouriersQueryVariables>(
    GQL_QUERY_ALL_COURIERS,
    { variables, fetchPolicy: 'cache-and-network' }
  )

export const useLazyFetchCouriers = (variables?: AllCouriersQueryVariables) => 
  useLazyQuery(GQL_QUERY_ALL_COURIERS, {
    variables
  })